import CalendarContainer from "../../../Components/Applications/Calendar/CalendarContainer";

const Calendar = () => {
  return <CalendarContainer />;
};

export default Calendar;
